import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../hooks/useAuth';

interface AdminRouteProps {
  children: React.ReactNode;
}

/**
 * Wrapper component that protects admin routes
 * Redirects to home if user is not an admin
 */
export function AdminRoute({ children }: AdminRouteProps) {
  const { user, loading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!isAuthenticated) {
        // Not logged in - redirect to login
        navigate('/login');
      } else if (!user?.isAdmin) {
        // Logged in but not admin - redirect to home
        navigate('/');
      }
    }
  }, [loading, isAuthenticated, user, navigate]);

  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Only render children if user is admin
  if (isAuthenticated && user?.isAdmin) {
    return <>{children}</>;
  }

  // Show nothing while redirecting
  return null;
}
